<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
	<mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
		<button mat-icon-button disabled></button>
		{{node.key}} : {{node.value}}
	</mat-tree-node>

	<mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
		<button class="mr-1" mat-icon-button matTreeNodeToggle (click)="expansionModel.toggle(node.id)"
			[attr.aria-label]="'toggle ' + node.key">
			<mat-icon class="mat-icon-rtl-mirror">
				{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
			</mat-icon>
		</button>
		{{node.key}} : {{node.value}}
		<!-- <ng-container *transloco="let t">
			<form *ngIf="treeControl.isExpanded(node)" [formGroup]="searchFormGroup">
				<mat-form-field class="fuse-mat-dense ml-2 fuse-mat-no-subscript fuse-mat-rounded min-w-64">
					<input matInput formControlName="searchControl" [(ngModel)]="expr"
						[autocomplete]="'off'">
				</mat-form-field>
			</form>
			<button *ngIf="treeControl.isExpanded(node)" mat-icon-button matTreeNodeToggle (click)="filterNode(node)">
				<mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
			</button>
		</ng-container> -->
	</mat-tree-node>
</mat-tree>